import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanDeactivate,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { BannerPageComponent } from '../pages/cms/banner/banner-page.component';
import { FormChangedGuard } from './form-changed-guard/form-changed-guard';

@Injectable({
  providedIn: 'root',
})
export class BannerFormChangedGuard
  extends FormChangedGuard
  implements CanDeactivate<BannerPageComponent>
{
  canDeactivate(
    component: BannerPageComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.handleNavigation(
      component.hasUnsavedChanges(component.bannerForm),
      nextState.url,
      () => component.resetFormChanges,
      () => component.save()
    );
  }
}
